export const cancelCallFromUser = (message, reducers, data, connection) => {
  const { eventsDispatch } = reducers;
  eventsDispatch({ type: 'CALL_CANCEL', payload: message.payload });
};
